import { DateField, EmailField, FunctionField, ShowButton, useListContext } from 'react-admin';
import isString from 'lodash/isString';
import { ConditionalTextField, PillButtonField } from '@/components/fields';
import { OverlaidLogoLoader } from '@/components/loaders';
import { PROFILE_STATUS_COLOR_MAP, PROFILE_STATUS_VALUE_MAP } from '@/pages/Candidate/constants';
import ComposedPackageName from '@/pages/components/ComposedPackageName';
import { MainDatagridStyled } from '@/styles/overrides';
import { path } from '../constants';
import { getFilteredNameValue } from '../utils';

const Datagrid = () => {
  const { isFetching } = useListContext();

  return (
    <>
      {isFetching && <OverlaidLogoLoader />}
      <MainDatagridStyled bulkActionButtons={false} className="turn-main-list" rowClick={false}>
        <DateField source={path('date_initiated')} label="Date Initiated" />
        <ConditionalTextField sortable={false} source={path('turn_id')} label="Turn ID" />
        <FunctionField
          label="Full Name"
          sortBy={path('display_name')}
          render={(record) => {
            const value = record?.[path('display_name')];
            return isString(value) ? getFilteredNameValue(value) : null;
          }}
        />
        <ConditionalTextField source={path('partner_name')} label="Partner" />
        <ConditionalTextField sortable={false} source={path('phone_number')} label="Phone Number" />
        <EmailField source={path('candidate_email')} label="Email" />
        <FunctionField
          label="Package"
          sortable={false}
          source="package"
          render={(record) => (
            <ComposedPackageName
              countryCode={record?.package?.country_code}
              packageName={record?.package?.name}
              packageId={record?.package?.package_id}
            />
          )}
        />
        <PillButtonField
          label="Profile Status"
          source={path('profile_status')}
          valueMap={PROFILE_STATUS_VALUE_MAP}
          colorMap={PROFILE_STATUS_COLOR_MAP}
        />
        <ShowButton />
      </MainDatagridStyled>
    </>
  );
};

export default Datagrid;
